<template>
  <b-form-group
    label="Kasa Hesabı"
    label-for="id_safes"
  >
    <v-select
      id="id_safes"
      v-model="filterParams.id_safes"
      :options="safes"
      label="title"
      :reduce="item => item.id"
      placeholder="Tümü"
      :disabled="filterParams.id_bank_accounts.length > 0"
      multiple
      @input="checkSelect"
    />
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup } from 'bootstrap-vue'

export default {
  name: 'SafeSelect',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    safes() {
      return this.$store.getters['safes/dataList']
    },
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
  created() {
    this.getSafes()
  },
  methods: {
    checkSelect() {
      if (this.filterParams.id_bank_accounts.length > 0) {
        this.filterParams.id_bank_accounts = []
      }
    },
    getSafes() {
      this.$store.dispatch('safes/getDataList')
    },
  },
}
</script>
